import { FC, useState, useLayoutEffect, useEffect } from 'react';

export const Clock: FC = () => {
  const [date, setDate] = useState<Date>(new Date());
  const [render, setRender] = useState<boolean>(false);

  function refreshClock(): void {
    setDate(new Date());
  }

  useLayoutEffect(() => {
    const timerId = setInterval(refreshClock, 1000);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);

  useEffect(() => {
    setRender(true);
  }, []);

  if (!render) return null;
  return <span>{date.toLocaleTimeString()}</span>;
};
